import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

const TipBox = styled.div`
  position: fixed;
  z-index: 2000;
  pointer-events: none;
  background: rgba(38, 38, 38, 0.95);
  color: #fff;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.45;
  max-width: 260px;
  white-space: pre-line;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
`;

type Props = {
  /** Viewport coordinates (clientX/clientY) to anchor near. */
  x: number;
  y: number;
  children: React.ReactNode;
};

/**
 * Instant, cursor-following tooltip rendered into document.body (so it isn't
 * clipped by the modal and isn't affected by transformed ancestors).
 */
const HoverTip: React.FC<Props> = ({ x, y, children }): React.ReactPortal => {
  const left = Math.min(x + 14, window.innerWidth - 270);
  const top = Math.min(y + 16, window.innerHeight - 90);
  return createPortal(<TipBox style={{ left, top }}>{children}</TipBox>, document.body);
};

export default HoverTip;
